/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { Formik, Field } from 'formik';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Box,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  Autocomplete,
  CardHeader,
  CardActions,
  TextField,
  Typography,
  Stack,
  MenuItem
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ValidateBankDetails } from '../../assets/validation';
import SettingAction from '../../store/actions/SettingAction';
import globalAction from '../../store/actions/GlobalAction';
import Loader from '../../utils/errorPages/Loader';
import EncryptData from '../../utils/EncryptData';
import DecryptData from '../../utils/DecryptData';

function BankConfigurationEdit() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dataItem, setDataItem] = useState('');
  const { bankItemData, isLoading } = useSelector((state) => state.setting);
  const { statusData, countryData, stateData, addressData } = useSelector((state) => state.global);

  const { code } = useParams();

  useEffect(() => {
    dispatch(SettingAction.getBankItem(code));
  }, [dispatch, code]);

  useEffect(() => {
    dispatch(globalAction.getCountryStatus());
    dispatch(globalAction.getClientStatus());
    dispatch(globalAction.getAddress());
  }, [dispatch]);

  const handleCountryChange = (countryId) => {
    dispatch(globalAction.getStateStatus(countryId));
  };

  useEffect(() => {
    if (bankItemData && bankItemData !== undefined) {
      let decryptJson;
      setTimeout(() => {
        decryptJson = DecryptData(bankItemData);
        setDataItem(decryptJson);
      }, 500);
    }
  }, [bankItemData]);

  useEffect(() => {
    if (dataItem && dataItem.country) {
      if (dataItem?.country?._id) {
        dispatch(globalAction.getStateStatus(dataItem.country._id));
      }
    }
  }, [dataItem, dispatch]);

  console.log(dataItem, 'dataItem');

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      {isLoading ? <Loader /> : ''}
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/settings/bank">
            Bank Configuration
          </Typography>
          <Typography component="h2" variant="h2">
            / Edit
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={{
          addresses: dataItem?.addresses ?? [],
          gstin: dataItem?.gstin ?? '',
          import_export_code: dataItem?.import_export_code ?? '',
          satellite_station: dataItem?.satellite_station ?? '',
          destination: dataItem?.destination ?? '',
          phone: dataItem?.phone ?? '',
          email: dataItem?.email ?? '',
          beneficiary_bank_account: dataItem?.beneficiary_bank_account ?? '',
          beneficiary_bank_name: dataItem?.beneficiary_bank_name ?? '',
          bank_address: dataItem?.bank_address ?? '',
          bank_city: dataItem?.bank_city ?? '',
          bank_state: dataItem?.state ?? null,
          bank_zip: dataItem?.bank_zip ?? '',
          bank_country: dataItem?.country ?? null,
          bank_phone: dataItem?.bank_phone ?? '',
          ifsc: dataItem?.ifsc ?? '',
          bank_routing_shift: dataItem?.bank_routing_shift ?? '',
          note: dataItem?.note ?? '',
          tax_id: dataItem?.tax_id ?? '',
          status: dataItem?.status ?? ''
        }}
        validationSchema={ValidateBankDetails}
        enableReinitialize
        onSubmit={(values, { setErrors, setSubmitting }) => {
          const newValues = { ...values };
          if (newValues.bank_country && newValues?.bank_country?.name) {
            newValues.bank_country = newValues.bank_country.name;
          }

          if (newValues.bank_state && newValues?.bank_state?.name) {
            newValues.bank_state = newValues.bank_state.name;
          }

          newValues.address_ids = (values.addresses ?? []).map((address) => address._id);
          delete newValues.addresses;

          const encrypt = EncryptData(newValues);
          const formData = {
            data: encrypt
          };

          dispatch(SettingAction.updateBank(code, formData, setErrors, setSubmitting, navigate));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          handleReset,
          handleSubmit,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <Grid container spacing={2}>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardHeader
                    title="Bank Details"
                    action={
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          setShow(!show);
                        }}
                      >
                        {show ? 'Hide All Details' : 'Show All Details'}
                      </Button>
                    }
                  />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <Autocomplete
                          multiple
                          className="CurrencyField"
                          options={addressData ?? []}
                          value={values.addresses}
                          onChange={(e, newvalue) => {
                            setFieldValue('addresses', newvalue);
                          }}
                          getOptionLabel={(option) => option.address_type}
                          isOptionEqualToValue={(option, value) =>
                            option.address_type === value.address_type
                          }
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.address_type}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="addresses"
                              error={!!errors.addresses}
                              helperText={
                                errors.addresses ||
                                'This bank becomes the active one for the selected addresses'
                              }
                              label="Office Addresses"
                              placeholder="Search Office Address"
                              variant="outlined"
                              margin="normal"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="beneficiary_bank_account"
                          name="beneficiary_bank_account"
                          label="Bank Account Number"
                          type={show ? 'text' : 'password'}
                          variant="outlined"
                          value={values.beneficiary_bank_account}
                          margin="normal"
                          inputProps={{
                            maxLength: 32
                          }}
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                            handleBlur(e);
                          }}
                          error={
                            touched.beneficiary_bank_account &&
                            Boolean(errors.beneficiary_bank_account)
                          }
                          helperText={
                            touched.beneficiary_bank_account && errors.beneficiary_bank_account
                          }
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="beneficiary_bank_name"
                          name="beneficiary_bank_name"
                          label="Bank Name"
                          type={show ? 'text' : 'password'}
                          variant="outlined"
                          margin="normal"
                          onChange={handleChange}
                          value={values.beneficiary_bank_name}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={
                            touched.beneficiary_bank_name && Boolean(errors.beneficiary_bank_name)
                          }
                          helperText={touched.beneficiary_bank_name && errors.beneficiary_bank_name}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="ifsc"
                          name="ifsc"
                          label="Bank IFSC Code"
                          type={show ? 'text' : 'password'}
                          variant="outlined"
                          margin="normal"
                          inputProps={{
                            maxLength: 16
                          }}
                          value={values.ifsc}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.ifsc && Boolean(errors.ifsc)}
                          helperText={touched.ifsc && errors.ifsc}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_routing_shift"
                          name="bank_routing_shift"
                          type={show ? 'text' : 'password'}
                          label="Bank Routing Shift"
                          variant="outlined"
                          margin="normal"
                          inputProps={{
                            maxLength: 16
                          }}
                          value={values.bank_routing_shift}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_routing_shift && Boolean(errors.bank_routing_shift)}
                          helperText={touched.bank_routing_shift && errors.bank_routing_shift}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_phone"
                          name="bank_phone"
                          label="Bank Phone Number"
                          variant="outlined"
                          margin="normal"
                          value={values.bank_phone}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            setFieldValue('bank_phone', values.bank_phone);
                          }}
                          error={touched.bank_phone && Boolean(errors.bank_phone)}
                          helperText={touched.bank_phone && errors.bank_phone}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_address"
                          name="bank_address"
                          label="Bank Address"
                          variant="outlined"
                          margin="normal"
                          value={values.bank_address}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_address && Boolean(errors.bank_address)}
                          helperText={touched.bank_address && errors.bank_address}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="bank_country"
                          component={Autocomplete}
                          className="CurrencyField"
                          options={countryData ?? []}
                          value={values.bank_country}
                          // disableClearable
                          onChange={(e, newvalue) => {
                            setFieldValue('bank_country', newvalue);
                            setFieldValue('bank_state', null);
                            if (newvalue && newvalue._id) {
                              handleCountryChange(newvalue._id);
                            }
                          }}
                          loading={isLoading}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="bank_country"
                              error={touched.bank_country && !!errors.bank_country}
                              helperText={touched.bank_country && errors.bank_country}
                              label="Select Country"
                              placeholder="Search Country"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                            />
                          )}
                        />
                        {/* <TextField
                          fullWidth
                          id="bank_country"
                          name="bank_country"
                          label="Bank Country"
                          variant="outlined"
                          margin="normal"
                          value={values.bank_country}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_country && Boolean(errors.bank_country)}
                          helperText={touched.bank_country && errors.bank_country}
                          required={false}
                          InputLabelProps={{ required: true }}
                        /> */}
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="bank_state"
                          component={Autocomplete}
                          className="CurrencyField"
                          value={values.bank_state}
                          options={stateData ?? []}
                          // disableClearable
                          onChange={(e, newvalue) => {
                            setFieldValue('bank_state', newvalue);
                          }}
                          loading={isLoading}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="bank_state"
                              error={touched.bank_state && !!errors.bank_state}
                              helperText={touched.bank_state && errors.bank_state}
                              label="Select State"
                              placeholder="Search State"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                            />
                          )}
                        />
                        {/* <TextField
                          fullWidth
                          id="bank_state"
                          name="bank_state"
                          label="Bank State"
                          variant="outlined"
                          margin="normal"
                          value={values.bank_state}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_state && Boolean(errors.bank_state)}
                          helperText={touched.bank_state && errors.bank_state}
                          required={false}
                          InputLabelProps={{ required: true }}
                        /> */}
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_city"
                          name="bank_city"
                          label="Bank City"
                          variant="outlined"
                          margin="normal"
                          value={values.bank_city}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.bank_city && Boolean(errors.bank_city)}
                          helperText={touched.bank_city && errors.bank_city}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="bank_zip"
                          name="bank_zip"
                          label="Bank ZIP Number"
                          variant="outlined"
                          margin="normal"
                          value={values.bank_zip}
                          onChange={handleChange}
                          // onBlur={(e) => {
                          //   handleBlur(e);
                          //   const val = (e.target.value || '').replace(/\s+/gi, '');
                          //   setFieldValue(e.target.name, val.trim());
                          // }}
                          error={touched.bank_zip && Boolean(errors.bank_zip)}
                          helperText={touched.bank_zip && errors.bank_zip}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
                <Card sx={{ borderRadius: '0px', mt: 2 }}>
                  <CardHeader title="Organisation Details" />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={1}>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="email"
                          type="email"
                          name="email"
                          label="Email"
                          variant="outlined"
                          margin="normal"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.email && Boolean(errors.email)}
                          helperText={touched.email && errors.email}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="phone"
                          name="phone"
                          label="Phone Number"
                          variant="outlined"
                          margin="normal"
                          value={values.phone}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.phone && Boolean(errors.phone)}
                          helperText={touched.phone && errors.phone}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="gstin"
                          name="gstin"
                          type={show ? 'text' : 'password'}
                          label="GSTIN"
                          inputProps={{
                            maxLength: 15
                          }}
                          variant="outlined"
                          margin="normal"
                          value={values.gstin}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.gstin && Boolean(errors.gstin)}
                          helperText={touched.gstin && errors.gstin}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="import_export_code"
                          name="import_export_code"
                          type={show ? 'text' : 'password'}
                          label="Import-Export Code"
                          variant="outlined"
                          inputProps={{
                            maxLength: 10
                          }}
                          margin="normal"
                          value={values.import_export_code}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.import_export_code && Boolean(errors.import_export_code)}
                          helperText={touched.import_export_code && errors.import_export_code}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="satellite_station"
                          name="satellite_station"
                          label="Satellite Station"
                          variant="outlined"
                          margin="normal"
                          inputProps={{
                            maxLength: 32
                          }}
                          value={values.satellite_station}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.satellite_station && Boolean(errors.satellite_station)}
                          helperText={touched.satellite_station && errors.satellite_station}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="destination"
                          name="destination"
                          label="Destination"
                          variant="outlined"
                          margin="normal"
                          inputProps={{
                            maxLength: 32
                          }}
                          value={values.destination}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.destination && Boolean(errors.destination)}
                          helperText={touched.destination && errors.destination}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="tax_id"
                          name="tax_id"
                          label="Tax ID"
                          type={show ? 'text' : 'password'}
                          variant="outlined"
                          margin="normal"
                          value={values.tax_id}
                          inputProps={{
                            maxLength: 11
                          }}
                          onChange={handleChange}
                          onBlur={(e) => {
                            const val = (e.target.value || '').replace(/\s+/gi, '');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.tax_id && Boolean(errors.tax_id)}
                          helperText={touched.tax_id && errors.tax_id}
                          required={false}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          id="status"
                          fullWidth
                          label="Status"
                          name="status"
                          margin="normal"
                          select
                          value={values.status}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.status && touched.status}
                          helperText={errors.status && touched.status && errors.status}
                          required={false}
                          InputLabelProps={{ required: true }}
                        >
                          {statusData &&
                            statusData.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {option.status}
                              </MenuItem>
                            ))}
                        </TextField>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="note"
                          name="note"
                          label="Note"
                          multiline
                          maxRows={3}
                          variant="outlined"
                          margin="normal"
                          inputProps={{
                            maxLength: 128
                          }}
                          value={values.note}
                          onChange={handleChange}
                          onBlur={(e) => {
                            handleBlur(e);
                            const val = (e.target.value || '').replace(/\s+/gi, ' ');
                            setFieldValue(e.target.name, val.trim());
                          }}
                          error={touched.note && Boolean(errors.note)}
                          helperText={touched.note && errors.note}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12} xl={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardActions sx={{ justifyContent: 'center', p: 3 }}>
                    <Button
                      type="submit"
                      className="save__btn"
                      variant="contained"
                      color="secondary"
                      // fullWidth
                      disabled={isSubmitting}
                      size="medium"
                    >
                      {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="primary"
                      size="medium"
                      onClick={() => {
                        navigate('/settings/bank');
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      variant="contained"
                      // fullWidth
                      color="info"
                      size="medium"
                      onClick={() => {
                        handleReset();
                      }}
                    >
                      Clear
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </Box>
  );
}
export default BankConfigurationEdit;
